import { Box, Text, Grid, Flex } from 'theme-ui'

export default function Info() {
  return (
    <Flex
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        py: [8, 8, 9],
        px: [5, 5, 6]
      }}
    >
      <Box sx={{ maxWidth: 1230, position: 'relative', marginTop: '36px' }}>
        <Grid gap={2} columns={['1fr', '1fr', '1fr 1fr']}>
          <Text
            as="h1"
            sx={{
              fontFamily: 'heading',
              fontSize: [6, 6, 8],
              lineHeight: 1.1,
              pr: [0, 0, 4],
              maxWidth: 580
              // color: 'white',
            }}
            color="discord"
          >
            Ride the Bus is about to hit the Blockchain
          </Text>
          <Text
            as="p"
            sx={{
              fontSize: [2, 2, 4],
              fontWeight: 300,
              color: 'white'
            }}
          >
            Ride the Bus brings a whole new level of innovation to the world of
            NFT collections. The aesthetic captures the essence of urban
            mobility, nostalgia, cypherpunk, and artistic expression. A diverse
            collection of 4545 one-of-a-kind buses, each meticulously crafted
            with intricate details and imaginative designs, all via Midjourney
            Artifical Inteligence.
            <br />
            Powered by the verifiable randomness generation capabilities of
            Chainlink, the protocol ensures transparency, security, and
            provenance for every digital asset, allowing collectors to truly own
            and showcase their prized bus NFTs.
          </Text>
        </Grid>
      </Box>
    </Flex>
  )
}
